<template>
    <v-toolbar dark color="primary">
        <v-toolbar-title class="font-weight-black">J-REIT個人投資家アンケート（個別銘柄投資経験なし）</v-toolbar-title>
    </v-toolbar>
</template>

<script>
export default {
  name: 'HeaderToolbar',
  components: {
  }
}
</script>
